const uploadUrl = process.env.NEXT_PUBLIC_UPLOAD_DESTINATION;

const TYPES = {
  full: {
    width: 1600,
    height: null,
    fit: 'inside'
  },
  web: {
    width: 380,
    height: null,
    fit: 'inside'
  },
  preview: {
    width: 200,
    height: null,
    fit: 'inside'
  },
  thumb: {
    width: 60,
    height: 60,
    fit: 'cover'
  }
};

export function resizeImage(uri, type = 'full') {
  if (!uri) {
    return uri;
  }

  // Resizing for AWS
  if (uri.includes(uploadUrl)) {
    const query = {
      bucket: process.env.NEXT_PUBLIC_S3_BUCKET,
      key: uri.replace(`${uploadUrl}/`, ''),
      edits: {
        rotate: null
      }
    };

    if (type && TYPES[type]) {
      query.edits.resize = {
        fit: TYPES[type].fit,
        width: TYPES[type].width,
        height: TYPES[type].height,
        withoutEnlargement: true
      };
    }

    return `${uploadUrl}/${btoa(JSON.stringify(query))}`;
  }

  return uri;
}

export const resizeAllImages = (
  dataArray,
  type = 'full',
  imageProp = 'image'
) => {
  if (!Array.isArray(dataArray) || !dataArray.length) {
    return dataArray;
  }

  return dataArray.map((d) => ({
    ...d,
    [imageProp]: resizeImage(d[imageProp], type)
  }));
};
